"use client";

import type { State } from "@frontend/lib/graphql/generated-gql";
import {
  useBoundStore,
  useBoundStoreBase,
} from "@frontend/lib/stores/globalStore";
import { useEffect, useRef } from "react";

export function GlobalStoreInitializer({
  orgId,
  isEligibilityCheckEnabled,
  minimumAge,
  allowedStates,
  proceedWithUnverifiedInsurance,
}: {
  orgId: number;
  isEligibilityCheckEnabled: boolean;
  minimumAge: number | null;
  allowedStates: State[] | null;
  proceedWithUnverifiedInsurance: boolean;
}) {
  const setStorefrontOrgId = useBoundStore.use.setStorefrontOrgId();
  const setMinimumAge = useBoundStore.use.setMinimumAge();
  const setAllowedStates = useBoundStore.use.setAllowedStates();
  const setProceedWithUnverifiedInsurance =
    useBoundStore.use.setProceedWithUnverifiedInsurance();
  const resetAllStores = useBoundStore.use.resetAllStores();
  const hasCheckedOrg = useRef(false);

  useEffect(() => {
    if (!hasCheckedOrg.current) {
      hasCheckedOrg.current = true;
      const { storefrontOrgId } = useBoundStoreBase.getState();
      if (storefrontOrgId !== null && storefrontOrgId !== orgId) {
        resetAllStores();
      }
    }

    setStorefrontOrgId(orgId);
    setProceedWithUnverifiedInsurance(proceedWithUnverifiedInsurance);

    if (isEligibilityCheckEnabled) {
      if (minimumAge) {
        setMinimumAge(minimumAge);
      }
      if (allowedStates) {
        setAllowedStates(allowedStates);
      }
    }
  }, [
    orgId,
    setStorefrontOrgId,
    setMinimumAge,
    setAllowedStates,
    setProceedWithUnverifiedInsurance,
    resetAllStores,
    isEligibilityCheckEnabled,
    minimumAge,
    allowedStates,
    proceedWithUnverifiedInsurance,
  ]);

  return null;
}
